import * as React from 'react';
export const trashSvg = React.forwardRef(function trashSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.5 3V1a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v2H.75a.75.75 0 0 0 0 1.5h.75V13a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V4.5h.75a.75.75 0 0 0 0-1.5H11.5ZM6 1.5V3h4V1.5H6Zm7 3H3V13a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 13 13V4.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.25 6.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75Zm3.5 0a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75Z',
    }),
  );
});
trashSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var trash = {
  category: 'icon',
  colorable: true,
  name: 'trash',
  svg: trashSvg,
};
